export enum LineHeights {
  'LINE_HEIGHTS_3' = '3',
  'LINE_HEIGHTS_4' = '4',
  'LINE_HEIGHTS_5' = '5',
  'LINE_HEIGHTS_6' = '6',
  'LINE_HEIGHTS_7' = '7',
  'LINE_HEIGHTS_8' = '8',
  'LINE_HEIGHTS_9' = '9',
  'LINE_HEIGHTS_10' = '10',
  'LINE_HEIGHTS_11' = '11',
  'NORMAL' = 'normal',
  'NONE' = 'none',
  'SHORTER' = 'shorter',
  'SHORT' = 'short',
  'BASE' = 'base',
  'TALL' = 'tall',
  'TALLER' = 'taller',
  'LINE_HEIGHTS_3_5' = '3-5',
  'LINE_HEIGHTS_4_5' = '4-5',
  'LINE_HEIGHTS_5_5' = '5-5',
  'LINE_HEIGHTS_6_5' = '6-5',
}
